/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function(ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function() {
        const response = fetch.apply(this, arguments);

        response.then(res => {
            if ([
                `${window.location.origin}/cart/add.js`
            ].includes(res.url)) {
                res.clone().json().then(function (cart) {
                    $.getJSON(window.Shopify.routes.root + 'cart.js', function(event){
                        var items = event.items;
                        var nonShippingItemCount = 0;
                        var nonShippingItems = [];
                        var shippingItemCount = 0;
                        var shippingItems = [];
                        for(var item of items) {
                            var productId = item.product_id;
                            if(item.requires_shipping == false){
                                nonShippingItems.push(item.variant_id);
                                nonShippingItemCount++;
                            }else{
                                shippingItems.push(item.variant_id);
                                shippingItemCount++;
                            }
                        }
                        if( nonShippingItemCount > 0 && nonShippingItemCount < items.length) {
                            alert("Earthquake Relief Campaign products and non-campaign products cannot be in the same shopping cart. Non-campaign products are removed from your cart.");
                            var payload = {};
                            for (var i=0; i < shippingItems.length; i++) {
                                payload[shippingItems[i]] = 0;
                            }
                            fetch(window.Shopify.routes.root + 'cart/update.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    updates: payload
                                })
                            }).then(response => {
                                window.location.reload();
                            });
                        }
                    });
                });
            }
        });

        return response;
    }
}(window, window.fetch));
